export class QuotaNumberCount {
  constructor(
    private readonly _clicks?: number,
    private readonly _completes?: number
  ) {}

  calculate(percentage: number): number {
    if (this._clicks === undefined && this._completes === undefined) {
      throw new Error(
        'Invalid arguments provided! Need either completes or clicks'
      );
    }

    const counter = this._clicks || this._completes;
    return Math.round((percentage * counter!) / 100);
  }
}
